// extracted by mini-css-extract-plugin
export default {"beanWrapper":"Auction_beanWrapper__gxcPw","beanContentCol":"Auction_beanContentCol__szvOJ","auctionActivityCol":"Auction_auctionActivityCol__KuMUP"};